import React, { Component } from "react";
import axios from "axios";

import { SegmentedItem, TableItemDinamico, dineroDisabledMask, ButtonItem, RangePickerItem, MensajeError } from "../../../Components/Items";
import { Tooltip, message, PageHeader, Tag, Popconfirm, notification } from "antd";
import { connect } from "react-redux";
import { CloseCircleOutlined, FileTextOutlined, BookFilled, SearchOutlined, FileProtectOutlined } from "@ant-design/icons";
import moment from "moment";
import MandarCorreoComplemento from "../CuentasPorCobrar/MandarCorreoComplemento/MandarCorreoComplemento";
import MandarCorreoPago from "../CuentasPorCobrar/MandarCorreoPago/MandarCorreoPago";
//import MandarCorreoPagos from "./MandarCorreoPagos/MandarCorreoPagos";
import CancelarPago from "../Ventas/CancelarPago/CancelarPago";
import CancelarPagoPdf from "../Ventas/CancelarPago/CancelarPagoPdf/CancelarPagoPdf";
import { obtenerEstadoCancelacion } from "../../../Utils/estatusSat.utils";

class PagosVentas extends Component {
    tableRef = null;
    state = {
        todasPagos: [],
        loading: false,
        totalRecords: 0,
        valor: 0,
        modalVerComplemento: false,
        modalVerComplementoId: null,
        modalVerPago: false,
        modalVerPagoId: null,
        modalCancelarPago: false,
        modalCancelarPagoId: null,
        modalCancelarPagoSoloTimbre: false,
        modalCancelarPagoPdf: false,
        modalCancelarPagoPdfId: null,
        fechaInicio: null,
        fechaFin: null,
    };

    cerrarModalCancelarPdf() {
        this.setState({
            modalCancelarPagoPdf: false,
            modalCancelarPagoPdfId: null,
        });
    }
    consultarPagos = (params) => {
        this.setState({ loading: true });

        axios
            .post(
                "pagos/selectPagosVenta",
                { empresaId: this.props.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasPagos:
                            res.data.data.map(value => {
                                return {
                                    ...value,
                                    folio: value.complemento ? ((value.complementoSerie || "") + " - " + (value.complementoNumero || "")) : ((value.pagoSerie || "") + " - " + (value.pagoNumero || "")),
                                    fechaNota: value.fechaNota ? value.fechaNota : value.createdAt,
                                    accion: { _id: value._id, estado: value.estado, complemento: value.complemento, jsonPago: value.jsonPago, jsonComplemento: value.jsonComplemento },
                                }
                            }),
                        totalRecords: res.data.totalRecords || 0,
                        loading: false
                    });
                } else {
                    this.setState({ todasPagos: [], loading: false, totalRecords: 0 });
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                message.error("Error al consultar los Pagos");
                console.log(err);
            });
    }



    enviarPagos(value) {
        this.setState({ modalVerPago: true, modalVerPagoId: value });
    }
    enviarComplemento(value) {
        this.setState({ modalVerComplemento: true, modalVerComplementoId: value });
    }
    cerrarVerComplemento() {
        this.setState({
            modalVerComplemento: false,
            modalVerComplementoId: null,
        });
    }
    cerrarMandarCorreoPago() {
        this.setState({
            modalVerPago: false,
            modalVerPagoId: null,
        });
    }

    cerrarCancelarPago(abrirPdf) {
        if (abrirPdf) {
            this.setState({
                modalCancelarPago: false,
                modalCancelarPagoId: null,
                modalCancelarPagoSoloTimbre: false,
                modalCancelarPagoPdf: true,
                modalCancelarPagoPdfId: this.state.modalCancelarPagoId
            });
            this.consultarPagos()
        } else {
            this.setState({
                modalCancelarPago: false,
                modalCancelarPagoId: null,
                modalCancelarPagoSoloTimbre: false,
            });
            this.consultarPagos()
        }
    }

    refrescarTabla() {
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({
                valor: this.state.valor,
                fechaInicio: this.state.fechaInicio,
                fechaFin: this.state.fechaFin,
            });
        }
    }

    //Consulta el estatus real del complemento de pago en el SAT. Si el SAT ya lo reporta cancelado
    //y el cobro sigue vigente en el sistema, el backend aplica la cancelacion local.
    checarEstatusFiscalComplemento(pagoId) {
        this.setState({ loading: true });
        axios
            .post(
                "pagos/checarEstatusFiscalComplementoPago",
                { pagoId, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2 && res.data.cancelada) {
                    message.success(res.data.message);
                } else if (res.data.success === 2) {
                    message.info(res.data.message);
                } else if (res.data.success === 3) {
                    notification.info({ message: "Ya estaba cancelado", description: res.data.message });
                } else {
                    // Aquí NO hay `errorTimbrado`: esto no es un rechazo del PAC, es la
                    // consulta al webservice de estatus del SAT, que `interpretarRespuestaSat`
                    // ya traduce ("El SAT no encontró este CFDI. Revisa que el RFC del
                    // emisor, el del receptor y el total coincidan..."). Lo que faltaba era
                    // mostrarlo con un título que diga algo y sin que se cierre solo.
                    MensajeError({
                        message: "No se pudo consultar el estatus en el SAT",
                        description: res.data.message,
                    });
                }
                this.refrescarTabla();
            })
            .catch((err) => {
                this.setState({ loading: false });
                message.error("Error al consultar el estatus fiscal");
                console.log(err);
            });
    }
    render() {
        /*
        Estados de cancelacion que devuelve el SAT:
        0 - Sin solicitud
        1 - En proceso
        2 - Plazo vencido
        3 - Solicitud rechazada
        4 - Cancelado sin aceptación
        5 - Cancelado con aceptación
        */

        const columns = [
            {
                title: "Folio",
                dataIndex: "folio",
                key: "folio",
                buscar: 'folio',
                width: "10%",
                render: (_, record) => {
                    //Solo los pagos con complemento de pago timbrado tienen estatus ante el SAT
                    const tieneComplemento = record.complemento && record.dataComplementoUuid;

                    let satColor = null;
                    let satTooltip = null;

                    if (tieneComplemento) {
                        if (record.estado === 0) {
                            if (record?.cancelacion?.statusCancelacion === 1) {
                                satColor = "#fa8c16";
                                satTooltip = `SAT: Cancelación en proceso (${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)})`;
                            } else if (record?.cancelacion?.statusCancelacion === 2) {
                                satColor = "#1E88E5";
                                satTooltip = "SAT: Cancelado";
                            } else if (record?.cancelacion?.statusCancelacion === 3) {
                                satColor = "#d4b106";
                                satTooltip = "SAT: Rechazada";
                            } else {
                                satColor = "#999999";
                                satTooltip = "SAT: Sin información";
                            }
                        } else {
                            satColor = "#52c41a";
                            satTooltip = "SAT: Vigente";
                        }
                    }

                    return (
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                            <span>{record.folio}</span>
                            {satColor && (
                                <Popconfirm
                                    title="Se consultará el estatus real de este complemento de pago en el SAT. Si aparece cancelado, se aplicará la cancelación del cobro en el sistema. ¿Continuar?"
                                    onConfirm={() => this.checarEstatusFiscalComplemento(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip title={satTooltip}>
                                        <SearchOutlined style={{ color: satColor, cursor: "pointer" }} />
                                    </Tooltip>
                                </Popconfirm>
                            )}
                        </div>
                    );
                },
            },

            {
                title: "Cliente",
                dataIndex: "cliente",
                key: "cliente",
                width: "18%",
                buscar: 'cliente',
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaPago",
                key: "fechaPago",
                defaultSortOrder: 'descend',
                sorter: true,
                render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm:ss"),
                width: "12%",
                ellipsis: true,
                align: "center",
            },
            {
                title: "Banco",
                dataIndex: "banco",
                key: "banco",
                align: "center",
                width: "13%",
                buscar: 'banco',
                ellipsis: true,
            },
            {
                title: "Forma de Pago",
                dataIndex: "formaDePago",
                key: "formaDePago",
                align: "center",
                width: "12%",
                ellipsis: true,
            },
            {
                title: "Monto",
                dataIndex: "monto",
                key: "monto",
                sorter: true,
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.monto)}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                buscar: "monto",
                width: "11%",
                ellipsis: true,
                align: "right",
            },
            {
                title: "Moneda",
                dataIndex: "moneda",
                key: "moneda",
                buscar: "moneda",
                responsive: [],
                width: 0,
            },

            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                render: (value, record) => {
                    if (value === 0) {
                        let satTag = null;

                        if (record.complemento && record.dataComplementoUuid) {
                            if (record?.cancelacion?.statusCancelacion === 1) {
                                satTag = (
                                    <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                                        <Tag color="orange" className="square-tag">SAT: Cancelación en proceso</Tag>
                                    </Tooltip>
                                );
                            } else if (record?.cancelacion?.statusCancelacion === 2) {
                                satTag = (
                                    <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                                        <Tag color="blue" className="square-tag">SAT: Cancelado</Tag>
                                    </Tooltip>
                                );
                            } else if (record?.cancelacion?.statusCancelacion === 3) {
                                satTag = (
                                    <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                                        <Tag color="yellow" className="square-tag">SAT: Rechazada</Tag>
                                    </Tooltip>
                                );
                            } else {
                                satTag = (
                                    <Tag color="gray" className="square-tag">SAT: Sin Información</Tag>
                                );
                            }
                        }

                        return (
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                                <Tag color="red" className="square-tag">Cancelado</Tag>
                                {satTag}
                            </div>
                        );
                    }
                    if (value === 1) {
                        return <Tag color="green" className="square-tag">Vigente</Tag>;
                    }

                },
                width: "13%",
                ellipsis: true,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                align: "center",
                width: "15%",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, record) => {
                    if (value.estado === 0) {
                        //Cancelado: se puede reimprimir el complemento (con marca de agua CANCELADO),
                        //imprimir el acuse de cancelacion del SAT y, si el SAT rechazo la cancelacion
                        //o se vencio el plazo (statusCancelacion 3), volver a pedirla.
                        let botonesCancelado = [];

                        const puedeVerComplemento = record.complemento && record.jsonComplemento;
                        if (puedeVerComplemento) {
                            botonesCancelado.push(
                                <Tooltip key={`ver-complemento-cancelado-${record._id}`} title="Ver PDF Complemento" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lila
                                        icon={<BookFilled />}
                                        onClick={() => this.enviarComplemento(value._id)}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            );
                        }

                        botonesCancelado.push(
                            <Tooltip key={`acuse-${record._id}`} title="Acuse de cancelación" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    naranja
                                    icon={<FileProtectOutlined />}
                                    onClick={() => this.setState({ modalCancelarPagoPdf: true, modalCancelarPagoPdfId: value._id })}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );

                        if (record.complemento && record.dataComplementoUuid && record?.cancelacion?.statusCancelacion === 3) {
                            botonesCancelado.push(
                                <Popconfirm
                                    key={`recancelar-${record._id}`}
                                    title="¿Cancelar nuevamente el timbre fiscal?"
                                    onConfirm={() =>
                                        this.setState({
                                            modalCancelarPago: true,
                                            modalCancelarPagoId: value._id,
                                            modalCancelarPagoSoloTimbre: true,
                                        })
                                    }
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip title="Reintentar cancelación SAT" placement="top">
                                        <CloseCircleOutlined style={{ color: "red", fontSize: 18, cursor: "pointer" }} />
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }

                        return <div className="acciones-container">{botonesCancelado}</div>;
                    }

                    let buttons = [];

                    const puedeVerPago = value.jsonPago && !value.complemento;
                    buttons.push(
                        <Tooltip key={`ver-pago-${record._id}`} title={puedeVerPago ? "Ver PDF" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                naranja
                                icon={<FileTextOutlined />}
                                onClick={() => puedeVerPago && this.enviarPagos(value._id)}
                                disabled={!puedeVerPago}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeVerComplemento = value.complemento && value.jsonComplemento;
                    buttons.push(
                        <Tooltip key={`ver-complemento-${record._id}`} title={puedeVerComplemento ? "Ver PDF Complemento" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                lila
                                icon={<BookFilled />}
                                onClick={() => puedeVerComplemento && this.enviarComplemento(value._id)}
                                disabled={!puedeVerComplemento}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeCancelar = record.estado !== 0 && !record.contado && !record.pagarVenta && !record.devolverDinero;
                    buttons.push(
                        <Tooltip key={`cancelar-${record._id}`} title={puedeCancelar ? "Cancelar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                rojo
                                icon={<CloseCircleOutlined />}
                                onClick={() => puedeCancelar && this.setState({ modalCancelarPago: true, modalCancelarPagoId: value._id, modalCancelarPagoSoloTimbre: false })}
                                disabled={!puedeCancelar}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];
        return (
            <>
                <PageHeader
                    title="Cobros de Ventas"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            <RangePickerItem
                                value={[
                                    this.state.fechaInicio ? moment(this.state.fechaInicio) : null,
                                    this.state.fechaFin ? moment(this.state.fechaFin) : null,
                                ]}
                                allowClear
                                onChange={(dates) => {
                                    const fechaInicio = dates?.[0] ? dates[0].startOf("day").toISOString() : null;
                                    const fechaFin = dates?.[1] ? dates[1].endOf("day").toISOString() : null;
                                    this.setState({ fechaInicio, fechaFin });
                                    if (this.tableRef) {
                                        this.tableRef.updateExternalFilters({
                                            valor: this.state.valor,
                                            fechaInicio,
                                            fechaFin,
                                        });
                                    }
                                }}
                                style={{ marginRight: 8 }}
                            />
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Todos', value: 0 }, { label: 'Vigentes', value: 1 }, {label: "Complemento", value: 3}, {label: "Pagos", value: 4}, { label: 'Canceladas', value: 2 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({
                                                valor: value,
                                                fechaInicio: this.state.fechaInicio,
                                                fechaFin: this.state.fechaFin,
                                            });
                                        }
                                        this.setState({ valor: value });
                                    }}

                                    value={this.state.valor}
                                />
                            }
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    /*onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/verPagos", { id: record._id });
                            },
                        };
                    }}*/
                    anadirValorFiltro={this.state.valor}
                    onClearFilters={() => this.setState({ fechaInicio: null, fechaFin: null })}
                    onFetchData={this.consultarPagos.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasPagos}
                    columns={columns}
                    filterStorageKey={"PagosFiltrosTabla" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={0}
                />
                <MandarCorreoComplemento
                    visible={this.state.modalVerComplemento}
                    id={this.state.modalVerComplementoId}
                    cerrarMandarCorreoComplemento={this.cerrarVerComplemento.bind(this)}
                />
                <MandarCorreoPago
                    visible={this.state.modalVerPago}
                    id={this.state.modalVerPagoId}
                    cerrarMandarCorreoPago={this.cerrarMandarCorreoPago.bind(this)}
                />
                <CancelarPago
                    visible={this.state.modalCancelarPago}
                    id={this.state.modalCancelarPagoId}
                    soloTimbre={this.state.modalCancelarPagoSoloTimbre}
                    cerrarCancelarPago={this.cerrarCancelarPago.bind(this)}
                />
                <CancelarPagoPdf
                    visible={this.state.modalCancelarPagoPdf}
                    pagoId={this.state.modalCancelarPagoPdfId}
                    onCancel={this.cerrarModalCancelarPdf.bind(this)}
                    cerrarModalCancelarPdf={this.cerrarModalCancelarPdf.bind(this)}
                />
            </>
        );



    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturaGlobal:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
            )?.activado,
    };
};

export default connect(mapStateToProps)(PagosVentas);